import { Component, ViewEncapsulation, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { VehicleBrand } from 'app/components/data/core/models/transport/transport';

import { LocaleService } from 'app/components/locale/locale.service';
import { brand } from '../../locale/locale';

import * as FormHelper from 'app/components/form-helper/form-helper';
import { CloudExecutor } from 'app/components/data/cloud-executors/cloud-executor';

@Component({
    selector   : 'vehicle-brand-dialog',
    templateUrl: './vehicle-brand-dialog.component.html',
    styleUrls  : ['./vehicle-brand-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class VehicleBrandDialog {

  public form: UntypedFormGroup;
  private object: VehicleBrand;

  public title: string;
  public buttonName: string;

  public dataSaver = new CloudExecutor;

  constructor (
    private localeService: LocaleService,
    public dialogRef: MatDialogRef<VehicleBrandDialog>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.localeService.loadLocale(brand);
    this.object = this._data.object;

    if (this._data.action === 'create') {
        this.title = 'DIALOG.CREATEBRAND.TITLE.CREATE';
        this.buttonName = 'DIALOG.CREATEBRAND.CONFIRMBUTTON.CREATE';
    } else if (this._data.action === 'edit') {
        this.title = 'DIALOG.CREATEBRAND.TITLE.EDIT';
        this.buttonName = 'DIALOG.CREATEBRAND.CONFIRMBUTTON.SAVE';
    }

    if (!this.object) {
      this.object = new VehicleBrand();
    }

    this.form = this.createContactForm();
  }

  createContactForm(): UntypedFormGroup
  {
    return this._formBuilder.group({
                name       : [this.object.name()],
              });
  }

  checkAndSave() {
    let verified = this.checkForm();

    if (verified) {
      this.object.setName(this.form.controls.name.value);

      this.dataSaver.saveObject(this.object).then(obj => {
        this.dialogRef.close(obj);
      });
    }
  }

  checkForm() : boolean {
    return FormHelper.checkForm(this.form);
  }
}
